var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createGlobalStyle as h, ThemeProvider as f, styled as n, css as i } from "styled-components";
import { jsxs as F, jsx as a } from "react/jsx-runtime";
import "react";
var s = {
    black10: "#081D2D",
    black20: "#213241",
    black30: "#394857",
    black40: "#52606E",
    black50: "#6C7886",
    black60: "#87929E",
    black70: "#A2ACB7",
    black80: "#BFC7D1",
    black90: "#DDE3EA",
    black95: "#EEF1F4",
    black99: "#F8F9FA",
    black100: "#FFFFFF",
    blue10: "#00366C",
    blue20: "#00478C",
    blue30: "#005FAB",
    blue40: "#0078C1",
    blue50: "#0091DF",
    blue60: "#00A6EE",
    blue70: "#18B7F7",
    blue80: "#74CFFF",
    blue90: "#B7E8FF",
    blue95: "#DAF4FF",
    blue99: "#F3FDFF",
    purple10: "#4A008C",
    purple20: "#5A00A4",
    purple30: "#6F00C4",
    purple40: "#8131CC",
    purple50: "#9B53DC",
    purple60: "#B573EC",
    purple70: "#CD93FB",
    purple80: "#E0B7FD",
    purple90: "#F0DBFE",
    purple95: "#F8EDFF",
    purple99: "#FEFBFF",
    red10: "#7F0020",
    red20: "#9A0034",
    red30: "#B60041",
    red40: "#CB004E",
    red50: "#DE2D68",
    red60: "#F05E83",
    red70: "#FF859F",
    red80: "#FFAABC",
    red90: "#FFCEDB",
    red95: "#FFE3EB",
    red99: "#FFF6F9",
    darkBlue10: "#0028AD",
    darkBlue20: "#0038C1",
    darkBlue30: "#004BD6",
    darkBlue40: "#0060E1",
    darkBlue50: "#0077ED",
    darkBlue60: "#4790F9",
    darkBlue70: "#7DAAFF",
    darkBlue80: "#A8C5FF",
    darkBlue90: "#CEE1FF",
    darkBlue95: "#E4F0FF",
    darkBlue99: "#F7FCFF",
    green10: "#00381A",
    green20: "#065128",
    green30: "#11703C",
    green40: "#268B54",
    green50: "#289F5E",
    green60: "#33B36E",
    green70: "#4AC684",
    green80: "#59D994",
    green90: "#7CECB0",
    green95: "#99F7C4",
    green99: "#D1FFE6",
    yellow10: "#4E2202",
    yellow20: "#7A3503",
    yellow30: "#AC4A03",
    yellow40: "#E16105",
    yellow50: "#F4890A",
    yellow60: "#FFA903",
    yellow70: "#FFC710",
    yellow80: "#FFD240",
    yellow90: "#FFDD6D",
    yellow95: "#FFEC8F",
    yellow99: "#FFFAD5",
    icon: "#0091DF"
  },
  A = Object.keys(s),
  z = function z(e, o) {
    return o in e.colors;
  },
  l = {
    desktop: "1440px",
    tablet: "1080px",
    tabletMd: "1024px",
    tabletSm: "768px",
    phone: "640px",
    phoneSm: "320px"
  },
  v = [10, 12, 14, 16, 20, 24, 26, 32, 40, 48],
  x = "/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */html{line-height:1.15;-webkit-text-size-adjust:100%}body{margin:0}main{display:block}h1{font-size:2em;margin:.67em 0}hr{box-sizing:content-box;height:0;overflow:visible}pre{font-family:monospace,monospace;font-size:1em}a{background-color:transparent}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:bolder}code,kbd,samp{font-family:monospace,monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:1.15;margin:0}button,input{overflow:visible}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}fieldset{padding:.35em .75em .625em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}progress{vertical-align:baseline}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}details{display:block}summary{display:list-item}template{display:none}[hidden]{display:none}",
  w = h(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n  }\n\n  body {\n    min-width: ", ";\n  }\n\n  body,\n  button,\n  input {\n    font-family: ", ";\n    color: ", ";\n  }\n  p,\n  a,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  input,\n  hr,\n  button,\n  section,\n  menu {\n    margin: 0;\n    padding: 0;\n  }\n  div,\n  section,\n  input,\n  button {\n    box-sizing: border-box;\n  }\n  input {\n    outline: none;\n  }\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover,\n  textarea:-webkit-autofill:focus,\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus {\n    transition: background-color 100s ease-in-out 0s;\n  }\n  button {\n    border: none;\n  }\n"])), x, l.phoneSm, function (_ref) {
    var e = _ref.theme;
    return e.fontFamily;
  }, function (_ref2) {
    var e = _ref2.theme;
    return e.colors.black10;
  }),
  S = function S(e, _ref3) {
    var _ref3$theme = _ref3.theme,
      o = _ref3$theme === void 0 ? B : _ref3$theme,
      d = _ref3.useGlobalStyles;
    var c = e.displayName || e.name || "Component",
      r = function r(m) {
        return /* @__PURE__ */F(f, {
          theme: o,
          children: [d && /* @__PURE__ */a(w, {}), /* @__PURE__ */a(e, _objectSpread({}, m))]
        });
      };
    return r.displayName = "withTheme(".concat(c, ")"), r;
  },
  t = {
    desktop: 1440,
    tablet: 1080,
    tabletMd: 1024,
    tabletSm: 768,
    phone: 640,
    phoneSm: 320
  },
  $ = function $(e) {
    var o = g(e);
    return ["phone", "phoneSm"].includes(o) ? "mobile" : ["tablet", "tabletMd", "tabletSm"].includes(o) ? "tablet" : "desktop";
  },
  g = function g(e) {
    return e < t.phone ? "phoneSm" : e >= t.phone && e < t.tabletSm ? "phone" : e >= t.tabletSm && e < t.tabletMd ? "tabletSm" : e >= t.tabletMd && e < t.tablet ? "tabletMd" : e >= t.tablet && e < t.desktop ? "tablet" : "desktop";
  },
  k = n.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  min-height: 16px;\n  font-size: 13px;\n"])));
n.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
n.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 10px;\n  line-height: 1;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  margin: 0;\n"])));
n.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
n(k)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-bottom: 0;\n  margin-top: 8px;\n  min-height: 1em;\n  font-size: 16px;\n"])));
n.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
n.p(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  line-height: 1;\n  letter-spacing: 0.1px;\n  color: ", ";\n"])), function (_ref4) {
  var e = _ref4.theme;
  return e.colors.red50;
});
i(["font-family:inherit;font-weight:400;font-size:16px;line-height:22px;", "{font-size:14px;}"], function (_ref5) {
  var e = _ref5.theme.down;
  return e("tablet");
});
var p = "0px 1px 8px rgba(0, 0, 0, 0.17)",
  b = "0px 4px 20px rgba(0, 0, 0, 0.07)",
  u = "0px 4px 28px rgba(0, 0, 0, 0.14)",
  T = i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], p),
  M = i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], b),
  j = i(["-webkit-filter:blur(0);will-change:filter;filter:drop-shadow(", ");"], u),
  N = i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], p),
  I = i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], b),
  G = i(["box-shadow:", ";-webkit-filter:blur(0);filter:blur(0);"], u),
  y = {
    size: {
      10: "10px",
      12: "12px",
      14: "14px",
      16: "16px",
      20: "20px",
      24: "24px",
      26: "26px",
      32: "32px",
      40: "40px",
      48: "48px"
    }
  },
  B = {
    name: "default",
    colors: s,
    icons: y,
    zIndex: {
      modal: 1080,
      tooltip: 999,
      datePicker: 959,
      toast: 9999,
      header: {
        overlay: 1060,
        menu: 1062,
        container: 1061
      },
      sticky: 1062
    },
    fontFamily: "'Noto Sans', 'Arial', sans-serif",
    up: function up(e) {
      return "@media (min-width: ".concat(l[e], ")");
    },
    down: function down(e) {
      return "@media (max-width: ".concat(l[e], ")");
    },
    between: function between(e, o) {
      return "@media (min-width: ".concat(l[e], ") and (max-width: ").concat(l[o], ")");
    }
  };
export { l as Breakpoints, w as GlobalStyles, t as NumericBreakpoints, N as boxShadow1, I as boxShadow2, G as boxShadow3, s as defaultColors, B as defaultTheme, $ as getBreakpoint, g as getBreakpointName, v as iconSizes, z as isThemeColor, T as shadowElevation1, M as shadowElevation2, j as shadowElevation3, A as themeColorList, S as withTheme };